setAnonymousUserEmailPreferencesData